import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { CatalogService } from 'features/catalog/service/service'

export { CatalogService } from 'features/catalog/service/service'

export function useCatalogService(): CatalogService {
  const client = useApiClient()
  return useMemo(() => new CatalogService(client), [client])
}
